export default {
  en: {
    noPermissions: {
      title: 'This feature is out of bounds',
      // meta.permissions is evaluated as any-of, so a singular lead over two
      // names reads as needing both.
      body1:
        'You need this permission to access it: | You need one of these permissions to access it:',
      body2: 'You can ask one of the following users to give you the right permissions:',
      backToPlatform: 'Back to platform',
    },
    notFound: {
      title: 'Page not found.',
      body1: "The page you're looking for may have been moved or no longer exists.",
      body2: 'If the issue persists try following the steps below:',
      refreshBrowser: 'Refresh your browser',
      incognito: 'Open this page in incognito/privacy mode',
      domainWhitelist: 'Ensure Risk Ledger domains are whitelisted by your IT team',
      contactSupport: 'If none of the above work, contact our customer support team',
      backToPlatform: 'Back to platform',
      helpCentre: 'Help centre',
    },
    downForMaintenance: {
      title: 'Scheduled maintenance in progress',
      body1:
        "We're currently undertaking some scheduled maintenance to improve Risk Ledger so the website is temporarily unavailable. We apologise for any inconvenience caused.",
      body2:
        'The website will be back online shortly, but if you need immediate assistance, reach out to {email} or {intercom}.',
      clickHere: 'click here',
      retry: 'Retry',
      stillDown: 'Risk Ledger is still unavailable. Please try again shortly.',
    },
  },
};
